var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8dcff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_1",
    "data-name": "cloud 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.19,461.78c48.83-5.6,89.05,40.76,137.81,47,45.94,5.83,87.94-24.67,122.84-55.1s72.28-64.29,118.49-67.26c50-3.2,93.74,30.6,133.13,61.5s86.09,62.33,135.37,53.48c32.14-5.77,58.53-27.81,87.62-42.64,62.21-31.74,140.71-29,200.52,7.1-54.84,7.66-92.34,57.83-121.87,104.68s-62.6,98.57-116,113.13c-83.18,22.67-162.67-56.93-248.83-54.19-50.52,1.6-95.12,31.14-139.15,56s-95.93,46.24-143.93,30.43C507.18,701,476.9,656.78,432.23,641c-59.18-20.88-123.81,13.65-186.34,8.33-66.92-5.7-125.81-63-133.35-129.71,44.53,16.53,98,51.28,145,29.33S332.08,469.16,386.19,461.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects15);
export default __webpack_public_path__ + "static/media/objects-15.1c2288528c26ef3f1a0dbaab4f05e9ae.svg";
export { ForwardRef as ReactComponent };